import React from 'react';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import 'picturefill';
import tracking from '../services/Tracking';
import { configuratorType } from '../i18n.js';

class Start extends React.Component {

  constructor(props) {
    super(props);
    console.log('props: ', props);

    this.handleStart = this.handleStart.bind(this);
  }

  componentDidUpdate() {
    // eslint-disable-next-line no-undef
    picturefill();
  }

  handleStart() {
    let trackingPage = configuratorType === 'water' ? 'watersystem-configurator/start' : 'showersystem-configurator/start';
    tracking.page(trackingPage);
  }

  render() {
    return (
      <div className="container">
        <div>
          {configuratorType === 'shower' &&          
          <picture className="picture picture--keyVisual">
            <source media="(min-width: 768px)" srcSet={require('../assets/images/start_m_shower.jpg')} />
            <img src={require('../assets/images/start_s_shower.jpg')} alt="" className="w-100" />
          </picture>
          }
          {configuratorType === 'water' &&          
            <picture className="picture picture--keyVisual">
              <source media="(min-width: 768px)" srcSet={require('../assets/images/start_m_water.jpg')} />
              <img src={require('../assets/images/start_s_water.jpg')} alt="" className="w-100" />
            </picture>
          }
          <Link to="/nl_nl/watersystems/configurator" onClick={this.handleStart} className="btn btn-primary button button--start1">
            <FormattedMessage id="homepage.buttonStart" />
          </Link>
        </div>
        <div className="row">
          <div className="col">
            <h1 className="text-uppercase headline headline--centerOnMD headline--h1">
              <span className="headline__inner"><FormattedMessage id="homepage.headline" /></span>
            </h1>
            <p className="text text--centerOnMD"><FormattedMessage id="homepage.introtext" /></p>
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            <Link to="/nl_nl/watersystems/configurator" onClick={this.handleStart} className="btn btn-primary button button--start2">
              <FormattedMessage id="homepage.buttonStart" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Start;



// WEBPACK FOOTER //
// ./src/components/Start.js